<template>
	<div class="flight-details pt-40">
		<div class="container">
			<div class="header-list d-flex flex-wrap text-capitalize text-white">
				<span class="bg-danger font-13 px-15 py-5">Trip Note</span>
			</div>
			<div class="box-shadow d-md-flex flex-wrap">
				<div class="description pl-30 pr- pt-25 pb-20">
					<div class="flight-header d-flex flex-wrap pb-28 mr-30">
						<div class="pl-13 pr-15">
							<span class="title text-pearl d-block mb-3">Note</span>
							<span class="data-value d-block">{{ description }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>

export default {
	props: {
		description:{
			type:String,
			required:true,
		},
	},
	data() {
		return {
		}
	},
}
</script>